<template>
  <el-row :gutter="20">
    <el-col :span="24">
      <!-- <header>
        <img src="../assets/zf-logo.png" width="100">
        <h1 class="demo">中国房地产企业榜单DEMO</h1>
      </header> -->
      <div style="width:80%;margin:0 auto;">

        <el-col style="margin-bottom:20px;">
          <el-button-group>
            <el-button icon="my-viewgallery" :type="show == 'menu' ? 'primary':''" @click="isshow('menu')"></el-button>
            <el-button icon="my-viewlist" :type="show == 'table' ? 'primary':''" @click="isshow('table')"></el-button>
          </el-button-group>
        </el-col>
        <el-col :span="6" v-for="(o,index) in data" :key="index"  v-if="show == 'menu'">
              <div class="grid-content bg-purple">
                <el-card class="box-card" style="position:relative">

                  <el-button type="text" @click="goNext(o.id,o.issub)">{{o.name}}</el-button>

                  
                  <el-tag style="position:absolute;bottom:10px;right:10px;" v-if="o.issub" type="Silver" close-transition><i class="el-icon-my-sort"></i></el-tag>
                </el-card>

              </div>
        </el-col>
        <el-col :span="24" v-if="show == 'table'">
          <el-table
            :data="data"
            border
            style="width: 100%">
            <el-table-column
              prop="name"
              align="left"
              label="奖项">
              <template scope="scope">
                 <el-button type="text" @click="goNext(scope.row.id,scope.row.issub)">{{scope.row.name}}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="tag"
              label="标签"
              width="100"
              :filters="[{ text: '有子榜单', value: 1 },{text: '无', value: 0}]"
              :filter-method="filterTag"
              filter-placement="bottom-end">
              <template scope="scope">
                <el-tag type="primary" v-if="scope.row.issub == 1" close-transition>{{formatIssub(scope.row.issub)}}</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-col>

      </div>
    </el-col>
    

  </el-row>
</template>
<script>
export default {
  name: 'list',
  data () {
   return {
      msg: '',
      show: 'menu',
      data: []
    }
  },
  mounted: function(){
      this.$nextTick(function () {
          this.$http.get('/api/awards/awards_list').then(
                response => {
                  this.data = response.data;
                },
                response => {
                  console.log('failed');
                }
              )
        })

  },
  methods: {
    goNext (id,issub) {
        if(issub){
          this.$router.push({ name: 'sublist', params: {id: id, issub: issub}});
        }else{
          this.$router.push({ name: 'thisdata', params: {id: id}});
        }
    },
    isshow (value) {
      this.show = value;
    },
    filterTag(value, row) {
        return row.issub === value;
    },
    formatIssub(value){
      return value === 1 ? '有子榜单' : '无';
    }

  }
}


</script>



// WEBPACK FOOTER //
// src/components/List.vue